import { FC, ReactNode, useRef } from 'react';

import Tab from '../../atoms/Tab';

import styles from './TabNavigation.module.scss';
import classNames from 'classnames';

const SCROLL_OFFSET_PADDING = 16;

const getArrowDirection = (index: number, selectedTab: number) =>
  selectedTab === index ? 'asc' : 'desc';

interface Props {
  activeTabName?: string;
  list: Array<{
    content?: ReactNode;
    label?: string;
    showArrow?: boolean;
    key?: string;
  }>;
  onTabClick: (tabName: string) => void;
  style?: 'fill' | 'hollow';
  tabsOrder: { [tabName: string]: number };
}

const TabNavigation: FC<Props> = ({
  activeTabName = '',
  list,
  onTabClick,
  style = 'fill',
  tabsOrder = {},
}) => {
  const activeTabIndex = activeTabName in tabsOrder ? tabsOrder[activeTabName] : 0; // Fallback (tabName): display 1st tab
  const tabNavigationRef = useRef<HTMLDivElement>(null);
  const styleForHrTag =
    style === 'hollow'
      ? styles['z-tab-hollow-navigation-border']
      : styles['z-tab-navigation-border'];

  const tabNames: Array<string> = [];
  Object.keys(tabsOrder).forEach((item, index) => {
    tabNames[index] = item;
  });

  return (
    <div className={styles['z-tab-navigation']}>
      <div
        className={classNames(styles['z-tab-navigation-list'], {
          [styles['z-tab-navigation-list-hollow']]: style === 'hollow',
        })}
        ref={tabNavigationRef}
      >
        {list.map(({ label, showArrow, key }, index) => (
          <Tab
            direction={showArrow ? getArrowDirection(index, activeTabIndex) : undefined}
            key={key}
            label={label}
            // eslint-disable-next-line react/jsx-no-bind
            onClick={(offsetLeft) => {
              tabNavigationRef.current?.scrollTo({
                behavior: 'smooth',
                left: (offsetLeft ?? 0) - SCROLL_OFFSET_PADDING,
                top: 0,
              });
              onTabClick(tabNames[index]);
            }}
            selected={activeTabIndex === index}
            style={style}
          />
        ))}
      </div>
      <hr className={styleForHrTag} />
      {list[activeTabIndex]?.content}
    </div>
  );
};

export default TabNavigation;
export type { Props as TabNavigationProps };
